import { publicApi } from '../../client';

export interface ChangePasswordParams {
  changeToken: string;
  newPassword: string;
}

/**
 * Forced (login-time) password change. Authorised by the short-lived `changeToken` issued with the
 * `password_change_required` challenge, sent as `Authorization: Bearer <changeToken>`. No
 * `currentPassword` is sent because the credential was just verified during login.
 */
export async function changePasswordRequest({ changeToken, newPassword }: ChangePasswordParams): Promise<void> {
  await publicApi.post(
    '/api/v1/auth/change-password',
    { newPassword },
    { headers: { Authorization: `Bearer ${changeToken}` } },
  );
}
